import axios, { AxiosRequestConfig } from 'axios';
import { API_MAP, ENV_VAR } from 'app/api';
import DEFAULTS from 'common/consts/defaults';
import { getPathnameFromUrl } from 'common/helpers/resolveHost';
import { history } from 'index';
import { getParamValue } from 'common/helpers/urlParams';


const getApiUrl = () => {
  const url = new URL(window.location.href);
  const locale = url.searchParams.get('locale') || 'fr';
  const api = API_MAP.get(process.env.NODE_ENV);
  return api[locale] || DEFAULTS.MARKET;
}

const httpOptions: AxiosRequestConfig = {
  baseURL: process.env.NODE_ENV === ENV_VAR.DEVELOPMENT ? getApiUrl() : '/',
  headers: { Accept: 'application/json+data' },
  withCredentials: true,
};

const http = axios.create(httpOptions);
// Alternative instance for follow redirects requests
export const fetcher = axios.create(httpOptions);

// Place for inteceptors
// In this place you can do something with response before it will go pass on
http.interceptors.response.use(
  (res) => {
    const requestPath = getPathnameFromUrl(res.config.url!);
    const responsePath = getPathnameFromUrl(res.request.responseURL);
    const pathToRedirect = res.data.RedirectUrl
      ? getPathnameFromUrl(res.data.RedirectUrl)
      : undefined;

    // Check is response has RedirectUrl property (then redirect)
    if (pathToRedirect) {
      history.push(pathToRedirect, { noRefresh: false });
    }

    // Check is requested path is not equal to response path (then redirect)
    if (requestPath !== responsePath) {

      if(!(responsePath.indexOf('/portal/') > -1))
      {
        window.location.href = responsePath;
        return;
      }
      else
      {
        history.push(responsePath, { noRefresh: false });            
      }    
    }
    return res;
  },
  (err) => {
    console.error(err);
    switch (err?.response?.status) {
      case 404:
        window.location.href = '/pageNotFound';
        break;
      default:
        break;
    }
  },
);

http.interceptors.request.use(
  (req: any) => {

    const search = window.location.search;
    const editParam = getParamValue(search, 'epieditmode');

    if(editParam === undefined)
      return req;

    req['epieditmode'] = editParam;

    return req;
  }
);


export default http;
